import * as React from 'react';
import classnames from 'classnames';
import s from './PaymentMethodLogo.scss';
export var PaymentMethodLogo = function (_a) {
    var cardBrand = _a.cardBrand, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React.createElement("div", { "data-hook": "payment-method-logo", "data-attrs": "cardBrand-".concat(cardBrand), className: classnames(s[cardBrand], className) }));
};
//# sourceMappingURL=PaymentMethodLogo.js.map